module.exports = __webpack_public_path__ + "img/4_ku.14129018.jpg";